export default {
    props: {
        select: Object,
        datePicker: Object,
        input: Object,
        table: Object,
        paginationDisabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    methods: {
        handleSelectChange(val) {
            this.$emit("select-change", val)
            this.$emit("get-data", 1)
        },
        handleDateChange(val) {
            this.$emit("date-change", val)
            this.$emit("get-data", 1)
        },
        handleInputChange(val) {
            this.$emit("input-change", val)
            this.$emit("get-data", 1)
        },
        handlePageChange(val) {
            this.$emit("get-data", val)
        }
    }
}
